import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptHashtags } from "src/features/Hashtags/adapters/adaptHashtags";

const fetchFavouriteFeeds = async () => {
	const response = await cmsClient.get<IAdminHashtag[]>(
		"/homepage/admin/favourite-feeds/"
	);

	return response.data;
};

const useFavouriteFeeds = () => {
	const query = useQuery(["favourite-feeds"], fetchFavouriteFeeds, {
		select: adaptHashtags
	});

	return query;
};

export default useFavouriteFeeds;
